<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <v-menu
      :open-on-hover="true"
      offset-y
      offset-x
      right
      top
      :nudge-right="-20"
      :nudge-top="-10"
    >
      <template v-slot:activator="{ on }">
        <v-avatar
          size="60"
          color="success"
          style="position:fixed; bottom:50px; left:20px; z-index:1; cursor:pointer;"
          v-on="on"
          @click.stop="whatsappWeb()"
        >
          <IconWhatsapp
            color="white"
            :size="42"
          />
        </v-avatar>
      </template>
      <v-card color="terciary darken-1">
        <v-card-text class="pa-2 white--text caption">
          ¿Necesitas ayuda? Escríbenos ahora...
        </v-card-text>
      </v-card>
    </v-menu>
    <v-container
      class="px-2"
      style="max-width: 800px;"
    >
      <div
        style="display:flex"
        class="my-2 align-center"
      >
        <div>
          <section>
            <h3 class="font-weight-light">
              Formulario
            </h3>
            <transition name="transition-opacity">
              <div>
                <h2 style="overflow-wrap:anywhere; display:inline;">
                  SOLICITUD DE OTORGACIÓN DE CREDENCIAL DE ACCESO A LA PLATAFORMA AJ EN LÍNEA
                </h2>
              </div>
            </transition>
          </section>
        </div>
        <v-spacer />
        <v-btn
          color="secondary"
          round
          :large="['lg', 'xl'].includes($vuetify.breakpoint.name)"
          class="ma-0"
          dark
          @click="retornar"
        >
          <v-icon
            dark
            class="ma-1"
          >
            arrow_back
          </v-icon> SALIR
        </v-btn>
      </div>
      
      <div v-show="!GetFormularioEnviado && !GetValidacionEnCurso.consultando">
     <v-card elevation="2" >
<IngresoCorreo/>
</v-card>
</div>

      <div v-show="!GetFormularioEnviado && GetValidacionEnCurso.consultando">
        <AvisosUsuario
          :mostrar="true"
          :validando="true"
          mensaje="Enviando información espere un momento porfavor."
        />
      </div>

      <div v-show="GetFormularioEnviado">
        <AvisosUsuario
          :mostrar="true"
          :validando="false"
          :mensaje="mensajeConf"
        />
      </div>
    </v-container>
  </div>
</template>

<script>

//componentes
import InformacionSin from '@/components/SolicitudCredenciales/InformacionSin'
import InformacionRepresentante from '@/components/SolicitudCredenciales/InformacionRepresentante'
import EnvioInformacion from '@/components/SolicitudCredenciales/EnvioInformacion.vue'
import AvisosUsuario from '@/components/SolicitudCredenciales/AvisosUsuario.vue';
import CustomAlert from "@/components/CustomAlert.vue";
import IconWhatsapp from "@/components/Icons/IconWhatsapp"
//store
import { mapActions, mapGetters, mapMutations } from 'vuex';
import typesCredenciales from '@/store/types/SolicitudCredenciales'

import { useRoute } from 'vue-router'
import IngresoCorreo from '../components/SolicitudCredenciales/IngresoCorreo.vue';

export default {
  components: {
    InformacionSin,//ya no
    InformacionRepresentante,//ya no
    EnvioInformacion,//ya no
    AvisosUsuario,
    CustomAlert,
    IconWhatsapp,
    IngresoCorreo,
  },
  data() {
    return {
      mostrar: false,
      e1: 1,
      steps: 2,
      btnSiguiente: "Siguiente",
      btnAtras: "Atrás",
      enBtnSiguiente: false,
      enBtnAtras: false,
      enviado: false,
      isHovered: false,
      mensajeConf: "Correo de confirmación enviado. Revice su correo (revise también la bandeja de correos no deseados)",
      messageWhatsapp: '',
      urlContactoWhatsappSoporte: `https://wa.me/${process.env.VUE_APP_NUMBER_WHATSAPP_SOPORTE}?text=`
    }
  },
  computed: {
    ...mapGetters({
      GetValidacionEnCurso: typesCredenciales.getters.GetValidacionEnCurso,
      GetFormularioEnviado: typesCredenciales.getters.GetFormularioEnviado,

    }),
   
  },
 
  methods: {
    retornar(){      
      this.$router.go(-1);
      //this.SetFormularioEnviado(false)
      
      
    },

    ...mapMutations({      
      SetFormularioEnviado: typesCredenciales.mutations.SetFormularioEnviado,

    }),
    
    whatsappWeb(){
      this.messageWhatsapp = `Hola, escribo para realizar la siguiente consulta:`
      window.open(this.urlContactoWhatsappSoporte + encodeURIComponent(this.messageWhatsapp), '_blank')
    },
  },
}

</script>

<style>
.table_documentos_adjuntados {
  border-collapse: collapse;
  width: 100%;

}

.table_documentos_adjuntados tr {
  border-bottom: 1px solid gray;
}

.table_documentos_adjuntados tr td {
  padding: 8px;
}

</style>
